import { makeStyles } from '@mui/styles';
import { COLOR_GRAY_70, COLOR_PURPLE } from 'styles/variables/colors';

export const useStyles = makeStyles((theme) => ({
  title: {
    fontSize: 32,
    fontWeight: 700,
    textAlign: 'center',
    color: theme.palette.common.white,
    height: 90,
  },
  mainBox: {
    borderRadius: 16,
    backgroundColor: theme.palette.common.white,
    gap: '16px',
    padding: theme.spacing(3, 4),
    maxWidth: 410,
  },
  steps: {
    display: 'flex',
  },
  numberStep: {
    position: 'relative',
    color: theme.palette.common.white,
    fontSize: 14,
    fontWeight: 700,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '23px',
    height: '23px',
    backgroundColor: COLOR_PURPLE,
    borderRadius: '50%',
    marginRight: theme.spacing(2),
    minWidth: '23px',
    minHeight: '23px',
  },
  verticalDivider: {
    '&::before': {
      display: 'block',
      position: 'absolute',
      top: 22,
      left: 10.5,
      content: '""',
      width: 2,
      height: 84,
      backgroundColor: COLOR_PURPLE,
    },
  },
  textStep: {
    color: COLOR_GRAY_70,

    '& span': {
      fontWeight: 700,
      color: COLOR_PURPLE,
    },
  },
}));
